import { render } from "./NotificationFilterListView.vue?vue&type=template&id=67fceaa4&scoped=true&ts=true"
import script from "./NotificationFilterListView.vue?vue&type=script&lang=ts"
export * from "./NotificationFilterListView.vue?vue&type=script&lang=ts"

import "./NotificationFilterListView.vue?vue&type=style&index=0&id=67fceaa4&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fceaa4"]])

export default __exports__